type AxiosLikeError = {
  code?: string;
  message?: string;
  response?: {
    status?: number;
    data?: unknown;
  };
};

const TECHNICAL_PATTERN =
  /sqlstate|pq:|duplicate key|panic:|EOF|multipart:|failed to parse|failed to open|failed to decode|unsupported image format|file size too large|request failed with status code|network error|err_network|econnaborted/i;

function readApiMessage(data: unknown): string {
  if (typeof data === 'string') {
    return data.trim();
  }
  if (data && typeof data === 'object') {
    const rec = data as Record<string, unknown>;
    if (typeof rec.message === 'string' && rec.message.trim()) {
      return rec.message.trim();
    }
    if (typeof rec.error === 'string' && rec.error.trim()) {
      return rec.error.trim();
    }
  }
  return '';
}

function isTechnicalMessage(message: string): boolean {
  return TECHNICAL_PATTERN.test(message);
}

export const CO_HOST_ACCESS_REVOKED = 'co_host_access_revoked';

export function getApiErrorCode(error: unknown): string | undefined {
  const data = (error as AxiosLikeError | undefined)?.response?.data;
  if (data && typeof data === 'object') {
    const rec = data as Record<string, unknown>;
    if (typeof rec.code === 'string' && rec.code.trim()) {
      return rec.code.trim();
    }
  }
  return undefined;
}

export function getApiErrorMessage(
  error: unknown,
  fallback = 'Terjadi kesalahan. Coba lagi.'
): string {
  const apiMessage = readApiMessage((error as AxiosLikeError | undefined)?.response?.data);
  if (apiMessage && !isTechnicalMessage(apiMessage)) {
    return apiMessage;
  }
  return fallback;
}

export function isCoHostAccessRevokedError(error: unknown): boolean {
  return getApiErrorCode(error) === CO_HOST_ACCESS_REVOKED;
}

export function getUploadErrorMessage(err: unknown, fallback: string): string {
  const error = (err ?? {}) as AxiosLikeError;
  const status = error.response?.status;
  const apiMessage = readApiMessage(error.response?.data);
  const code = error.code || '';
  const rawMessage = error.message || '';

  if (status === 413 || /too large|entity too large/i.test(apiMessage) || /too large|entity too large/i.test(rawMessage)) {
    return 'Ukuran foto terlalu besar untuk diunggah. Pilih foto yang lebih kecil lalu coba lagi.';
  }

  if (apiMessage && !isTechnicalMessage(apiMessage)) {
    return apiMessage;
  }

  if (code === 'ECONNABORTED' || /timeout/i.test(rawMessage)) {
    return 'Unggahan foto terlalu lama. Coba lagi dengan foto yang lebih kecil.';
  }

  if (code === 'ERR_NETWORK' || rawMessage === 'Network Error') {
    return 'Koneksi terputus saat mengunggah foto. Periksa internet lalu coba lagi.';
  }

  if (status && status >= 500) {
    return 'Server sedang bermasalah saat menyimpan foto. Coba beberapa saat lagi.';
  }

  return fallback;
}
